import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RecentSearchesComponent} from './recent-searches.component';
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {AngularSvgIconModule} from "angular-svg-icon";
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
    declarations: [
        RecentSearchesComponent
    ],
    exports: [
        RecentSearchesComponent
    ],
    imports: [
        CommonModule,
        ButtonModule,
        AngularSvgIconModule,
        TranslateModule
    ]
})
export class RecentSearchesModule { }
